import React from "react";
import "./SocialMedia.css";
import { socialMediaLinks } from "../../portfolio";
import styled from "styled-components";

const IconWrapper = styled.span`
  i {
    background-color: ${(props) => props.backgroundColor};
  }
  &:hover i {
    background-color: ${({ theme }) => theme.text};
    transition: 0.3s ease-in;
  }
`;

export default function socialMedia(props) {
  return (
    <div className="social-media-div">
      {socialMediaLinks.map((media, i) => {
        return (
          <a
            key={i}
            href={media.link}
            className={`icon-button`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconWrapper {...media} {...props}>
              {/* Prefer provided FA family (brands/solid); fall back to Iconify */}
              {media.fontAwesomeIcon ? (
                <i
                  className={`${media.className || "fa-brands"} ${
                    media.fontAwesomeIcon
                  }`}
                  aria-label={media.name}
                ></i>
              ) : null}
              {!media.fontAwesomeIcon && media.iconifyClassname ? (
                <span
                  className="iconify"
                  data-icon={media.iconifyClassname}
                  data-inline="false"
                  aria-label={media.name}
                ></span>
              ) : null}
            </IconWrapper>
            {/* <span></span> */}
          </a>
        );
      })}
    </div>
  );
}
